import { WordMO } from './WordMO';
import { WordTypeCountMO } from './WordTypeCountMO';

export class ParagraphMO {
	text: string;
	words: WordMO[];
	isHeading: boolean;
	isList: boolean;
	isTable: boolean;
	isLeftIndent: boolean;
	wc: number;
	wordTypeCount: WordTypeCountMO;

	constructor(
		text: string = '',
		words: WordMO[] = [],
		isHeading: boolean = false,
		isList: boolean = false,
		isTable: boolean = false,
		isLeftIndent: boolean = false,
		wc: number = 0,
	) {
		this.text = text;
		this.words = words;
		this.isHeading = isHeading;
		this.isList = isList;
		this.isTable = isTable;
		this.isLeftIndent = isLeftIndent;
		this.wc = wc;
	}
}
